<template>
  <TableReminder />
</template>
<script>
import TableReminder from "./components/tableReminder.vue";
export default {
  components: {
    TableReminder,
  },
  methods: {},
};
</script>
<style></style>
